document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.header-wrapper');
  const header = document.querySelector('.header');

  if (!wrapper || !header) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      wrapper.classList.add('scrolled');
      header.classList.add('scrolled');
    } else {
      wrapper.classList.remove('scrolled');
      header.classList.remove('scrolled');
    }
  });
});